$(document).ready(function(){

	// -- show alert banners --
	var showAlertBanner = sessionStorage.getItem('showAlertBanner');
	if (showAlertBanner != 'false') {
		$('.alertBanner').show();
	}

	// -- Alert banners --
	$('.alertBanner .btn--close').on('click', function(){
		// -- hide banners --
		$('.alertBanner').slideUp('fast');
		// -- set cookie --
		showAlertBanner = sessionStorage.setItem('showAlertBanner', 'false');
	});

});
